import React, { useState, useEffect } from 'react'

import './GainsAndCostsChart.css'
import IndicatorsPool from '../../../../js/IndicatorsPool'
import { VictoryChart, VictoryGroup, VictoryStack, VictoryBar, VictoryTooltip, VictoryAxis, VictoryPortal, VictoryLabel} from 'victory'
import MyTooltip from '../MyTooltip/MyTooltip'
import { store } from '../../../../stores/store'
import Translations from '../../../../js/Translations'



function getTotal(values) {
  let total = 0
  values.forEach(val => {
    total += val[0].y
  })
  return total

}


const GainsAndCostsChart = () => {



  let gainsIds = ["indF44", "indF42", "indF41", "indF168", "indF169"]
  let costsIds = ["indF137", "indF46", "indF47", "indF40", "indF43", "indF136", "indF85"]

  // let gainsData = compileIndicatorForCharts(gainsIds, null)
  // let costsData = compileIndicatorForCharts(costsIds, null)

  function getIndChart(id, colTitle) {
    const ind = IndicatorsPool.getIndicator(id)
    const val = IndicatorsPool.getIndicatorValue(id, true)

    return [
      {
        x: colTitle,
        y: parseFloat(val),
        label: `${ind.title}${Translations.chartSeparator}${val}${ind.unit}`
      }
    ]
  }

  let gains_data = gainsIds.map(id => getIndChart(id, store.t("gains")))
  let costs_data = costsIds.map(id => getIndChart(id, store.t("costs")))

  // NOTE: tout ca pour afficher une barre de différence entre les 2 blocs
  let totalGains =  getTotal(gains_data)
  let totalCosts =  getTotal(costs_data)

  let diff = getIndChart("indEc5", " ") // hack: le " " pour ne pas avoir de label en abcisse
  let color = diff[0].y >= 0 ? "green" : "red"
  diff[0].style = { data: { fill: color } }
  diff[0].y0 = Math.min(totalCosts, totalGains)
  diff[0].y = Math.abs(diff[0].y)







  return (
    <div className="GainsAndCostsChart">
      <VictoryChart
      animate={{onLoad: { delay: 0, duration: 1 }, duration: 500}}
      padding={{left: 100, top: 30, bottom: 30}}
      domainPadding={{ x: 100, y: 0 }}
      width={400}
      height={300}

      >

        <VictoryGroup offset={0}>


          <VictoryStack colorScale="grayscale" >
            {gains_data.map((d, i) => <VictoryBar barWidth={50} key={i} data={d} labelComponent={<MyTooltip />} />)}
          </VictoryStack>

          <VictoryStack>
            <VictoryBar style={diff[0].style} barWidth={10} data={diff} labelComponent={<MyTooltip />} />
          </VictoryStack>

          <VictoryStack colorScale="blue">
            {costs_data.map((d, i) => <VictoryBar barWidth={50} key={i} data={d} labelComponent={<MyTooltip />} />)}
          </VictoryStack>
        </VictoryGroup>

        <VictoryAxis />

        <VictoryAxis
        dependentAxis
        label={store.t("gains_n_costs_Y_label")}
        tickFormat={(t) => t}
        axisLabelComponent={<VictoryLabel dy={-50} />}  />

      </VictoryChart>

    </div>
  );
};

export default GainsAndCostsChart;
